(() => {
  const initialise = (form) => {
    if (form.dataset.origineReady === "true") return;
    form.dataset.origineReady = "true";

    form.addEventListener("submit", async (event) => {
      event.preventDefault();
      if (!form.reportValidity()) return;

      const button = form.querySelector('[type="submit"]');
      const status = form.querySelector("[data-origine-prospect-status]");
      const successTemplate = form.querySelector("[data-origine-success-message]");
      const initialLabel = button.textContent;

      button.disabled = true;
      button.textContent = "Envoi en cours…";
      status.textContent = "";
      status.removeAttribute("data-state");

      try {
        const response = await fetch(form.action, {
          method: "POST",
          body: new FormData(form),
          headers: { Accept: "application/json" },
        });
        const payload = await response.json().catch(() => ({}));
        if (!response.ok) {
          throw new Error(payload.error || "Une erreur est survenue. Réessayez.");
        }

        form.reset();
        status.dataset.state = "success";
        status.textContent =
          successTemplate?.content?.textContent?.trim() ||
          "Merci, votre demande a bien été transmise à l’équipe Origine.";
      } catch (error) {
        status.dataset.state = "error";
        status.textContent =
          error instanceof Error
            ? error.message
            : "Une erreur est survenue. Réessayez.";
      } finally {
        button.disabled = false;
        button.textContent = initialLabel;
      }
    });
  };

  document
    .querySelectorAll("[data-origine-prospect-form]")
    .forEach(initialise);

  document.addEventListener("shopify:section:load", (event) => {
    event.target
      .querySelectorAll("[data-origine-prospect-form]")
      .forEach(initialise);
  });
})();
